import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Bug icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Bug } from '@sravni/design-system-icons'
 *
 * <Bug />
 * ```
 */
var Bug = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Bug", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m15.238 5.635-.873 1.746-1.164.8M3.889 10h2.715M13.396 10h2.715M4.762 2.143h-.873c-.965 0-1.746.781-1.746 1.746v.873M15.238 17.857h.873c.965 0 1.746-.781 1.746-1.746v-.873M2.143 15.238v.873c0 .965.78 1.746 1.746 1.746h.873M17.857 4.762V3.89c0-.965-.781-1.746-1.746-1.746h-.873M4.762 5.635l.873 1.746 1.163.8M10.387 14.366h-.776a2.619 2.619 0 0 1-2.619-2.62V9.127c0-.964.782-1.746 1.746-1.746h2.522c.965 0 1.746.782 1.746 1.746v2.62a2.619 2.619 0 0 1-2.619 2.619ZM4.762 14.365l.873-1.746 1.163-.8M15.238 14.365l-.873-1.746-1.164-.8M11.746 7.381H8.254V5.635c0-.482.391-.873.873-.873h1.746c.482 0 .873.391.873.873v1.746Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Bug };
//# sourceMappingURL=Bug.js.map
